import { render, staticRenderFns } from "./DataValue.vue?vue&type=template&id=48c4a222&scoped=true&"
import script from "./DataValue.vue?vue&type=script&lang=ts&"
export * from "./DataValue.vue?vue&type=script&lang=ts&"
import style0 from "./DataValue.vue?vue&type=style&index=0&id=48c4a222&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c4a222",
  null
  
)

export default component.exports